// @core/api/endpoints/workflow/create_prompt_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePromptTemplateRequest,
  PromptTemplateResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Create prompt template
 * Creates a reusable AI prompt template with declared variables. The llm.prompt node references templates by id, so authoring one adds an AI capability without any code.
 */
export async function CreatePromptTemplate(
  data: CreatePromptTemplateRequest,
  options?: RequestOptions
): Promise<PromptTemplateResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/prompt-templates`;
  const requestOptions = options;
  return client.post<PromptTemplateResponse>(requestPath, data, requestOptions);
}
